import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Box, CircularProgress, Alert, Button,
  TextField, InputAdornment, IconButton
} from '@mui/material';
import { 
  GridComponent, ColumnsDirective, ColumnDirective, 
  Inject, Toolbar, Filter, Sort 
} from '@syncfusion/ej2-react-grids';
import PeopleIcon from '@mui/icons-material/People';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { cicassService } from '../../../../_services'; // Verifica il percorso corretto

const SummaryDialog112 = ({ open, onClose, calendarId, year, month, apiUrl, t }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (open) {
      loadData();
    } else {
      setData([]);
      setSearchText('');
    }
  }, [open, calendarId, year, month]);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    try {
      const lang = localStorage.getItem("weblang") || "it";
      const { data: mc } = await cicassService.getAll(
        `${apiUrl}/monthlycheck/${calendarId},${year},${month},${lang}`
      );
      setData(mc || []);
    } catch (err) {
      setError("Errore nel caricamento dei dati.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Filtro locale per la ricerca rapida
  const filteredData = data.filter(item => 
    item.nameSurname?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.userNote?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: 'primary.main', color: 'white' }}>
        <PeopleIcon />
        <Typography sx={{color: "white"}}>{t("calendarMonthProgressive")}</Typography>
      </DialogTitle>

      <DialogContent sx={{ mt: 2, minHeight: '400px' }}>
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <TextField
            size="small"
            placeholder={t("Cerca volontario o nota...")}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>),
              endAdornment: searchText && (
                <IconButton size="small" onClick={() => setSearchText('')}><ClearIcon /></IconButton>
              )
            }}
          />
        </Box>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <GridComponent dataSource={filteredData} allowPaging={false} height="400">
            <ColumnsDirective>
              <ColumnDirective field="nameSurname" headerText={t("calendarNameSurname")} width="180" />
              <ColumnDirective field="monthProgressive" headerText={t("calendarMonthProgressive")} width="100" textAlign="Center" />
              <ColumnDirective field="monthMaxDescr" headerText={t("calendarMaxDescr")} width="150" />
              <ColumnDirective 
                field="userNote" 
                headerText={t("Note")} 
                width="200" 
                clipMode="EllipsisWithTooltip" // Utile se la nota è lunga
              />
            </ColumnsDirective>
            <Inject services={[Sort, Filter]} />
          </GridComponent>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">{t("okBtn")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SummaryDialog112;